import { render, staticRenderFns } from "./SaleBonusModal.vue?vue&type=template&id=054f6a72&scoped=true&"
import script from "./SaleBonusModal.vue?vue&type=script&lang=js&"
export * from "./SaleBonusModal.vue?vue&type=script&lang=js&"
import style0 from "./SaleBonusModal.vue?vue&type=style&index=0&id=054f6a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f6a72",
  null
  
)

component.options.__file = "SaleBonusModal.vue"
export default component.exports